const Request = require('@/repositories/request')

class Cache extends Request {
  async removeByLabel(label) {
    return await this.$strapi.$http.$delete(`/caches/remove-by-label/${label}`)
  }
}

module.exports = Cache
